import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { noop } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserInfo } from '../../auth/models/user';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat-support.component.html',
})
export class ChatSupportComponent implements OnInit, OnDestroy {
  @Input() currentUser: UserInfo;
  fcWidget: any = {
    init: noop,
    destroy: noop,
    isOpen: noop,
    isInitialized: noop,
    user: {
      setProperties: noop,
      open: noop,
      close: noop,
    },
  };
  chatNotSupportMsg = 'Chat With Support is currently unavailable';
  chatSupportMsg = 'Chat With Support';
  tooltipText: string;

  constructor() {
    if ((window as any).fcWidget) {
      this.fcWidget = (window as any).fcWidget;
    }
  }

  ngOnInit() {
    this.tooltipText = this.chatNotSupportMsg;
    if (
      environment?.chat?.enabled &&
      environment?.chat?.regionWhitelist.includes(this.currentUser?.region)
    ) {
      this.fcWidget.init({
        // shared token for all environments
        token: environment.chat.fcToken,
        host: environment.chat.wchatUrl,
        // required, supposedly
        externalId: this.currentUser.userName,
        config: {
          headerProperty: {
            hideChatButton: true,
          },
        },
      });

      this.fcWidget.on('widget:loaded', () => {
        this.tooltipText = this.chatSupportMsg;
      });
    }
  }
  toggleShowChat = () => {
    if (!this.fcWidget.isOpen()) {
      this.fcWidget.user
        .setProperties({
          firstName: this.currentUser.firstName,
          lastName: this.currentUser.lastName,
          email: this.currentUser.promo
            ? 'TrialWeb@trimble.com'
            : this.currentUser.userName,
          account: this.currentUser.account,
        })
        .then(() => {
          this.fcWidget.open();
        });
    } else {
      this.fcWidget.close();
    }
  };

  ngOnDestroy() {
    this.fcWidget.destroy();
  }
}
